import { createAuthClient } from "better-auth/react";

// 1.D.3 Better-Auth client.
//
// Vite proxyn (apps/web/vite.config.ts) takia /api/* osuu API:n samaan
// originiin → cookie kulkee same-origin -saannolla. Tuotannossa web ja API
// elavat saman domainin alla (kratti.example + api.kratti.example
// tai pelkka domain) jolloin baseURL voi viela jaada origin-relatiiviseksi.
//
// Better-Auth:n basePath default on /api/auth, joten ainoastaan baseURL
// (origin) tarvitsee asettaa.
export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : undefined,
});
